import { useEffect, useRef, useState } from "react"
import { Formik, Field, Form } from "formik"
import {
    InputGroup,
    FieldWrappers,
    Label,
    SubmitBtn,
    SideCancelBtn,
    Wrapper,
    CombineInputGroup,
    ActionSection,
    ScrollableContent,
    CardWrapper,
    SelectionCard,
    ModalHeader,
} from "../Styles/InputStyles"
import { toast } from "react-toastify"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import PayerDropdown from "../PayerDropdown"
import { useSelector } from "react-redux"
import moment from "moment"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaRegCalendar } from "react-icons/fa";
import CategoryCard from "../CategoryCard"
import PaidToUserModal from "./PaidToUserModal"
import PaidUserModal from "./PaidUserModal"

const EditRecurringExpense = ({
    handleClose,
    selectedData,
    editRecurringExpenseMutate,
    editRecurringExpenseLoading,
    expenseData,
}) => {
    const [calendarOpen, setCalendarOpen] = useState(false);
    const formikRef = useRef(null)
    const [userValues, setUserValues] = useState({
        amount: selectedData?.amount || "",
        dueDate: selectedData?.dueDate ? moment(selectedData.dueDate).format("YYYY-MM-DD") : "",
        expenseId: selectedData?.id,
        noOfMonths: selectedData?.noOfMonths || 1,
        description: selectedData?.description || "",
        paymentCycle: selectedData?.paymentCycle || "",
    })
    const [showPaidByModal, setShowPaidByModal] = useState(false)
    const [showPaidToModal, setShowPaidToModal] = useState(false)
    const [selectedPaidBy, setSelectedPaidBy] = useState(null);
    const [selectedPaidTo, setSelectedPaidTo] = useState(null);
    const [isInitialized, setIsInitialized] = useState(false);
    const [height, setHeight] = useState(window.innerHeight);
    const [cycleType, setCycleType] = useState(userValues.paymentCycle || 1)

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (selectedData) {
            const paidByUser = expenseData?.users?.find((user) => user.id == selectedData.paidBy)
            const paidToVendor = expenseData?.vendors?.find((vendor) => vendor.id == selectedData.paidTo)

            setSelectedPaidBy(paidByUser || null)
            setSelectedPaidTo(paidToVendor || null)

            if (!isInitialized) {
                setUserValues({
                    amount: selectedData?.amount || "",
                    dueDate: selectedData?.dueDate ? moment(selectedData.dueDate).format("YYYY-MM-DD") : "",
                    expenseId: selectedData?.id,
                    noOfMonths: selectedData?.noOfMonths || 1,
                    description: selectedData?.description || "",
                    paymentCycle: selectedData?.paymentCycle || "",
                })
                setIsInitialized(true)
            }
        }
    }, [selectedData, expenseData, isInitialized])


    const handleFormChange = (e) => {
        if (e && e.target) {
            const { name, value } = e.target
            if (name && (name === "amount" || name === "dueDate" || name === "description" || name === "noOfMonths")) {
                setUserValues((prev) => ({
                    ...prev,
                    [name]: value,
                }))
            }
        }
    }

    const initialValues = {
        amount: userValues.amount,
        dueDate: userValues.dueDate,
        paidBy: selectedPaidBy?.id || "",
        paidTo: selectedPaidTo?.id || "",
        description: userValues.description,
        expenseId: selectedData?.id,
        noOfMonths: userValues.noOfMonths,
        paymentCycle: userValues.paymentCycle,
    }

    const handleSelectedPaidBy = (selectedOption) => {
        setSelectedPaidBy(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("paidBy", selectedOption.id)
            formikRef.current.setFieldValue("paidByUserType", selectedOption.userType)
        }
    }

    const handleSelectedPaidTo = (selectedOption) => {
        setSelectedPaidTo(selectedOption)
        if (formikRef.current) {
            formikRef.current.setFieldValue("paidTo", selectedOption.id)
            formikRef.current.setFieldValue("paidToUserType", selectedOption.userType)
        }
    }

    const handleSubmit = (values) => {
        const amountRegex = /^(?!0+$)\d{1,6}$/
        const maxAmount = 1000000

        if (!amountRegex.test(values.amount) || Number.parseInt(values.amount) > maxAmount) {
            toast.error("Monthly rent must be between 1 and 10,00,000 and contain only numbers")
            return
        }

        if (!values.dueDate) {
            toast.error("Due date is required")
            return
        }

        if (!values.paidBy) {
            toast.error("Paid by is required")
            return
        }
        if (!values.paidTo) {
            toast.error("Paid to is required")
            return
        }

        if (!values.noOfMonths || values.noOfMonths <= 0) {
            toast.error("Number of months must be greater than 0")
            return
        }
        if (!values.paymentCycle) {
            toast.error("Payment cycle is required")
            return
        }
        editRecurringExpenseMutate({
            amount: Number(values.amount),
            description: values.description,
            dueDate: moment(values.dueDate).format("YYYY-MM-DDTHH:mm:ss[Z]"),
            paidBy: Number(values.paidBy),
            paidTo: Number(values.paidTo),
            paidByUserType: Number(selectedPaidBy.userType),
            paidToUserType: Number(selectedPaidTo.userType),
            expenseId: Number(selectedData.id),
            noOfMonths: Number(values.noOfMonths),
            paymentCycle: Number(values.paymentCycle)
        });
    }

    const handleCancel = () => {
        handleClose()
    }

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <ModalHeader>
                <h1 className="text-white text-lg font-medium">Edit Recurring Expense</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <div className="px-6 h-full flex flex-col justify-between">
                <Formik innerRef={formikRef} initialValues={initialValues} onSubmit={handleSubmit} enableReinitialize>
                    {({ values, setFieldValue, handleChange, handleBlur, errors, touched }) => (
                        <Form onChange={handleFormChange}>
                            <ScrollableContent className="max-h-[calc(100vh-140px)]">
                                <Wrapper>
                                    <InputGroup>
                                        <Label htmlFor="amount">Amount *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="text"
                                                name="amount"
                                                id="amount"
                                                className={`w-full truncate`}
                                                value={userValues.amount}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                    setUserValues((prev) => ({
                                                        ...prev,
                                                        amount: e.target.value,
                                                    }))
                                                }}
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <CombineInputGroup>

                                        <InputGroup>
                                            <Label htmlFor="paidBy">Paid by *</Label>
                                            <CategoryCard
                                                title="Paid By"
                                                selectedCategory={selectedPaidBy}
                                                onClick={() => setShowPaidByModal(true)}
                                            />

                                        </InputGroup>
                                        <InputGroup>
                                            <Label htmlFor="paidTo">Paid to *</Label>
                                            <CategoryCard
                                                title="Paid to"
                                                selectedCategory={selectedPaidTo}
                                                onClick={() => setShowPaidToModal(true)}
                                            />

                                        </InputGroup>
                                    </CombineInputGroup>

                                    <InputGroup>
                                        <Label htmlFor="dueDate">Due Date *</Label>
                                        <FieldWrappers className="relative">

                                            <DatePicker
                                                selected={userValues.dueDate ? new Date(userValues.dueDate) : null}
                                                onChange={(date) => {
                                                    const formattedDate = moment(date).format("YYYY-MM-DD");
                                                    handleChange({
                                                        target: {
                                                            name: "dueDate",
                                                            value: formattedDate,
                                                        },
                                                    });
                                                    setUserValues((prev) => ({
                                                        ...prev,
                                                        dueDate: formattedDate,
                                                    }));
                                                    setCalendarOpen(false);
                                                }}
                                                onClickOutside={() => setCalendarOpen(false)}
                                                onSelect={() => setCalendarOpen(false)}
                                                open={calendarOpen}
                                                onInputClick={() => setCalendarOpen(true)}
                                                dateFormat="yyyy-MM-dd"
                                                className="w-full truncate cursor-pointer"
                                                placeholderText="YYYY-MM-DD"
                                                showIcon
                                                icon={<FaRegCalendar className="text-gray-400 text-xs mt-0.5" />}
                                                showPopperArrow={false}
                                                onFocus={(e) => e.target.blur()}
                                                wrapperClassName="w-full"
                                                required
                                                name="dueDate"
                                                id="dueDate"
                                                autoComplete="off"
                                                popperPlacement="bottom-start"
                                                portalId="root-portal"
                                                popperClassName="react-datepicker-popper"
                                            />
                                        </FieldWrappers>
                                    </InputGroup>

                                    <InputGroup>
                                        <Label htmlFor="noOfMonths">Number of Months *</Label>
                                        <FieldWrappers>
                                            <Field
                                                type="number"
                                                name="noOfMonths"
                                                id="noOfMonths"
                                                min="1"
                                                className={`w-full truncate`}
                                                value={userValues.noOfMonths}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                    setUserValues((prev) => ({
                                                        ...prev,
                                                        noOfMonths: e.target.value,
                                                    }))
                                                }}
                                            />
                                        </FieldWrappers>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label>
                                            Payment Cycle *
                                        </Label>
                                        <CardWrapper>
                                            <SelectionCard
                                                type="button"
                                                onClick={() => {
                                                    setCycleType(1);
                                                    formikRef.current?.setFieldValue("paymentCycle", 1);
                                                }}
                                                className={cycleType === 1
                                                    ? "bg-primary-color text-white"
                                                    : "bg-gray-100"}
                                            >
                                                <span className="text-sm ">{"Advance"}</span>
                                            </SelectionCard>
                                            <SelectionCard
                                                type="button"
                                                onClick={() => {
                                                    setCycleType(2);
                                                    formikRef.current?.setFieldValue("paymentCycle", 2);
                                                }}
                                                className={cycleType === 2
                                                    ? "bg-primary-color text-white"
                                                    : "bg-gray-100"}
                                            >
                                                <span className="text-sm ">{"Month End"}</span>
                                            </SelectionCard>
                                        </CardWrapper>
                                    </InputGroup>
                                    <InputGroup>
                                        <Label htmlFor="description">Description </Label>
                                        <Field
                                            as={Textarea}
                                            id="description"
                                            name="description"
                                            rows={5}
                                            placeholder="Enter Description"
                                            value={userValues.description}
                                            onChange={(e) => {
                                                handleChange(e)
                                                setUserValues((prev) => ({
                                                    ...prev,
                                                    description: e.target.value,
                                                }))
                                            }}
                                        />
                                    </InputGroup>

                                </Wrapper>
                            </ScrollableContent>
                            <ActionSection>
                                <SideCancelBtn type="button" onClick={handleCancel}>
                                    Cancel
                                </SideCancelBtn>

                                <SubmitBtn type="submit" disabled={editRecurringExpenseLoading}>
                                    {editRecurringExpenseLoading ? "Submitting..." : "Submit"}
                                </SubmitBtn>
                            </ActionSection>
                            <PaidUserModal
                                isOpen={showPaidByModal}
                                onClose={() => setShowPaidByModal(false)}
                                onSelect={handleSelectedPaidBy}
                                options={expenseData?.users}
                                selectedPaidBy={selectedPaidBy}
                            />
                            <PaidToUserModal
                                isOpen={showPaidToModal}
                                onClose={() => setShowPaidToModal(false)}
                                onSelect={handleSelectedPaidTo}
                                options={expenseData?.vendors}
                                landlordList={expenseData?.landlords}
                                selectedPaidTo={selectedPaidTo}
                                title="Select Paid To"
                            />
                        </Form>
                    )}
                </Formik>
            </div>
        </Container>
    )
}

const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`
const Textarea = tw.textarea`min-h-10 max-h-40 border border-gray-300 rounded pl-2 py-2 focus:ring-1 focus:ring-sky-600  focus:border-sky-600 focus:outline-none duration-200 w-full h-20 resize-y  break-words overflow-hidden`

export default EditRecurringExpense